import * as R from "ramda";

/**
 * @param  {Number} currentPage the selected page number
 * @param  {Number} blockRange how many pages on either side of the currentPage
 * @param  {Number} totalPages all pages, including hidden pages
 * @param  {Number} firstPage  0 or 1
 * @return {Array} an array of page number, eg [4, 5, 6, 7, 8]
 */
export function getPagerPages({
  currentPage = 1,
  blockRange = 2,
  totalPages,
  firstPage = 1,
}) {
  try {
    const before = currentPage - blockRange + firstPage;
    const after = currentPage + blockRange - firstPage;
    const lastPage = totalPages - 1 + firstPage;

    // if lastPage is 1, make sure we don't return [1, 2, 3], for example
    const filterPages = R.filter(
      (page) => page >= firstPage && page <= lastPage,
    );

    // if we're near the begining
    if (before < firstPage) {
      return filterPages(R.range(firstPage, after + 1));
    }
    // if we're near the end
    else if (after > lastPage) {
      return filterPages(R.range(before, R.min(lastPage, after) + 1));
    }
    // if we're in the middle
    else {
      return filterPages(R.range(before, after + 1));
    }
  } catch (error) {
    return [];
  }
}

/**
 * @param  {Number} currentPage  page number
 * @param  {Number} perPage      number of result per page
 * @param  {Number} totalResults number of all results
 * @return {String} the range of the current results eg. 20 - 41
 */
export function getCurrentResultsRange({ currentPage, perPage, totalResults }) {
  const start = (currentPage - 1) * perPage + 1;
  let end = start + perPage - 1;

  if (end > totalResults) {
    end = totalResults;
  }

  if (isNaN(start) || isNaN(end)) {
    return "";
  }

  return `${start} - ${end}`;
}

export default {
  getPagerPages,
  getCurrentResultsRange,
};
